// Jornaya (LeadiD) + TrustedForm consent-certification scripts.
//
// Both vendors watch the form and write their identifier into a hidden input
// that the page must keep mounted: name="leadid_token" for Jornaya and
// name="xxTrustedFormCertUrl" for TrustedForm. We read those inputs at submit
// time and send the values with the lead.
//
// Kept in one place because three separate lead forms load these — the
// campaign id must never drift between them.

export const LEADID_CAMPAIGN_KEY = '4f92abea-9576-ff28-406d-190d2255539f'
const LEADID_ACCOUNT_KEY = 'F687F0C3-5166-FEF0-1329-1B967270DE02'

/**
 * Injects both certification scripts plus the Jornaya <noscript> fallback.
 * Returns a cleanup function that removes what it added.
 */
export function injectLeadCertificationScripts(): () => void {
  // snippet_version=2 populates the leadid_token input directly, so no
  // callback global is needed.
  const leadIdScript = document.createElement('script')
  leadIdScript.id = 'LeadiDscript_campaign'
  leadIdScript.type = 'text/javascript'
  leadIdScript.async = true
  leadIdScript.src = `//create.lidstatic.com/campaign/${LEADID_CAMPAIGN_KEY}.js?snippet_version=2`
  document.body.appendChild(leadIdScript)

  // Mirrors the vendor's <noscript> tag: a tracking pixel for visitors with
  // JavaScript disabled.
  const noscript = document.createElement('noscript')
  const pixel = document.createElement('img')
  pixel.src = `//create.leadid.com/noscript.gif?lac=${LEADID_ACCOUNT_KEY}&lck=${LEADID_CAMPAIGN_KEY}&snippet_version=2`
  pixel.alt = ''
  noscript.appendChild(pixel)
  document.body.appendChild(noscript)

  const tfScript = document.createElement('script')
  tfScript.type = 'text/javascript'
  tfScript.async = true
  tfScript.src =
    'http' +
    ('https:' === document.location.protocol ? 's' : '') +
    '://api.trustedform.com/trustedform.js?provide_referrer=' +
    escape('false') +
    '&field=' +
    escape('xxTrustedFormCertUrl') +
    '&l=' +
    new Date().getTime() +
    Math.random()
  document.body.appendChild(tfScript)

  return () => {
    // Best-effort cleanup so StrictMode / route changes don't double-inject.
    for (const node of [leadIdScript, noscript, tfScript]) {
      try {
        node.parentNode?.removeChild(node)
      } catch {}
    }
  }
}
